import { RSVPOptionType } from '@models/event-attendance/rsvp-option-type.enum';

export enum DashboardEventTab {
  UPCOMING = 'UPCOMING',
  PAST = 'PAST',
  ALL = 'ALL',
  HOSTING = 'HOSTING',
  GOING = 'GOING',
  MAYBE = 'MAYBE',
  DRAFT = 'DRAFT',
  LIVE = 'LIVE',
}
export namespace DashboardEventTab {
  export function getAll(): DashboardEventTab[] {
    return [
      DashboardEventTab.ALL,
      DashboardEventTab.LIVE,
      DashboardEventTab.UPCOMING,
      DashboardEventTab.HOSTING,
      DashboardEventTab.GOING,
      DashboardEventTab.MAYBE,
      DashboardEventTab.DRAFT,
      DashboardEventTab.PAST,
    ];
  }

  export function getDisplayName(tab?: DashboardEventTab): string {
    switch (tab) {
      case DashboardEventTab.ALL:
        return 'APP.EVENTS.ALL';
      case DashboardEventTab.LIVE:
        return 'APP.EVENTS.LIVE';
      case DashboardEventTab.UPCOMING:
        return 'APP.EVENTS.UPCOMING';
      case DashboardEventTab.HOSTING:
        return 'APP.EVENTS.HOSTING';
      case DashboardEventTab.GOING:
        return 'APP.EVENTS.GOING';
      case DashboardEventTab.MAYBE:
        return 'APP.EVENTS.MAYBE';
      case DashboardEventTab.DRAFT:
        return 'APP.EVENTS.DRAFT';
      case DashboardEventTab.PAST:
        return 'APP.EVENTS.PAST';
      default:
        return '';
    }
  }

  export function getColor(optionType?: RSVPOptionType): string {
    switch (optionType) {
      case RSVPOptionType.YES:
        return '#33b977';
      case RSVPOptionType.MAYBE:
        return '#ffa723';
      default:
        return '#B0B0B0';
    }
  }
}
